// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export type LayoutThreeColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutThreeColumnShellProps = {
  left: JSX.Element;
  middle: JSX.Element;
  right: JSX.Element;
};

export const LayoutThreeColumnShell = ({
  left,
  middle,
  right,
}: LayoutThreeColumnShellProps): JSX.Element => {
  const middlePlaceholder = middle.props.rendering?.placeholders['nmdp-one-third-middle'];
  const middlePlaceholderIsEmpty = middlePlaceholder && middlePlaceholder.length === 0;
  const rightPlaceholder = right.props.rendering?.placeholders['nmdp-one-third-right'];
  const rightPlaceholderIsEmpty = rightPlaceholder && rightPlaceholder.length === 0;
  const colSpanCss = `col-span-1`;

  return (
    <div className={classnames('md:grid', 'grid-cols-3', 'md:gap-5', 'lg:gap-7')}>
      <div
        className={classnames(
          colSpanCss,
          { 'mb-10': !middlePlaceholderIsEmpty, 'mb-0': middlePlaceholderIsEmpty },
          'md:mb-0'
        )}
      >
        {left}
      </div>
      <div
        className={classnames(
          colSpanCss,
          { 'mb-10': !rightPlaceholderIsEmpty, 'mb-0': rightPlaceholderIsEmpty },
          'md:mb-0'
        )}
      >
        {middle}
      </div>
      <div className={classnames(colSpanCss, 'mb-0')}>{right}</div>
    </div>
  );
};

const LayoutThreeColumn = ({ rendering, fields }: LayoutThreeColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-three-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutThreeColumnShell
        left={<PlaceholderWrapper name="nmdp-one-third-left" rendering={rendering} />}
        middle={<PlaceholderWrapper name="nmdp-one-third-middle" rendering={rendering} />}
        right={<PlaceholderWrapper name="nmdp-one-third-right" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutThreeColumn;
